import * as actions from '../services'
// import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import * as types from './mutations-types'
// import { t } from 'src/utils/form'

export const listContractPlanEntries = (context, payload) => {
  return actions.getContractPlanEntries(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setContractPlanEntries, response.data.contract_plan_entries)
    }
    return response
  })
}

export const createContractPlanEntry = (context, payload) => {
  return actions.newContractPlanEntry(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setContractPlanEntry, response.data.contract_plan_entry)
    }
    return response
  })
}

export const editContractPlanEntry = (context, payload) => {
  return actions.updateContractPlanEntry(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setContractPlanEntry, response.data.contract_plan_entry)
    }
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/contract_plan_entries/vuex/actions.js